import { graphClient, gql } from '../graphql'

export const me = ({ commit, state }) => {
  const getMe = gql`
    query {
      me {
        id
        name
        picture
        role
        remainingDays
        daysPerYear {
          edges {
            node {
              id
              year
              remainingDays
              kaleiderId
              holidayType
              carryOver
            }
          }
        }
      }
    }
  `

  return graphClient.query({
    query: getMe,
    forceFetch: true
  })
    .then(user => {
      let daysPerYear = user.data.me.daysPerYear.edges
        .map(item => item.node)
        .filter(d => d.remainingDays > 0 && d.year <= state.selectedYear)

      const hasCarryOverDays = daysPerYear.filter(d => d.carryOver).length > 0
      if (hasCarryOverDays) {
        daysPerYear = daysPerYear.filter(d => d.carryOver)
      } else {
        daysPerYear = daysPerYear.filter(d => (!d.carryOver &&
                                               d.year === state.selectedYear))
      }

      const remainingDays = daysPerYear.reduce((ac, v) =>
        ac + v.remainingDays, 0)

      return commit('ME', {
        id: user.data.me.id,
        daysPerYear: daysPerYear,
        name: user.data.me.name,
        picture: user.data.me.picture,
        remainingDays: remainingDays,
        role: user.data.me.role,
        hasCarryOverDays: hasCarryOverDays}
      )
    })
}

export const importHolidays = ({ commit, state }) => {
  const mutationImportHolidays = gql`
    mutation importHolidays($input:ImportHolidaysInput!) {
      importHolidays(input:$input) {
        ok
        holidays {
          date
          name
        }
      }
    }
  `

  return graphClient.mutate({
    mutation: mutationImportHolidays,
    variables: {
      input: {}
    }
  })
    .then(data => {
      if (data.data.importHolidays.ok) {
        commit('SET_IMPORT_HOLIDAYS_SUCCESS', true)
      } else {
        throw data.data
      }
    })
    .catch(err => {
      console.error(err)
    })
}

export const vacations = ({commit, state}) => {
  const getVacations = gql`
    query ($kaleiderId: ID, $fromDate: String, $toDate: String) {
      vacations(kaleiderId: $kaleiderId, fromDate: $fromDate, toDate: $toDate) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            startDate
            endDate
            workingDays
            kaleider {
              id
              name
            }
          }
        }
      }
    }
  `

  const vacations = {
    kaleiderId: state.me.id,
    fromDate: `${state.selectedYear - 1}-09-01`,
    toDate: `${state.selectedYear + 1}-03-31`
  }

  return graphClient.query({
    query: getVacations,
    variables: vacations,
    forceFetch: true
  })
    .then(data => {
      let totalVacations = data.data.vacations.edges.map(res => res.node)
      return commit('GET_VACATIONS', totalVacations)
    })
    .catch(err => {
      console.error(err)
    })
}

export const holidays = ({commit, state}) => {
  const getHolidays = gql`
    query holidays {
      holidays {
        edges {
          node {
            date
            name
          }
        }
      }
    }
  `

  return graphClient.query({
    query: getHolidays,
    forceFetch: true
  })
    .then(data => {
      const TOTAL_HOLIDAYS = data.data.holidays.edges.map(res => res.node)
      return commit('GET_HOLIDAYS', TOTAL_HOLIDAYS)
    })
    .catch(err => {
      console.log(err)
    })
}

export const setStartDate = ({commit}, data) => {
  return commit('SET_START_DATE', data)
}

export const setEndDate = ({commit}, data) => {
  return commit('SET_END_DATE', data)
}

export const setHolidayName = ({commit}, data) => {
  return commit('SET_HOLIDAY_NAME', data)
}

export const setShowMore = ({commit}, data) => {
  return commit('SET_SHOW_MORE', data)
}

export const setCurrentView = ({commit}, data) => {
  return commit('SET_CURRENT_VIEW', data)
}

export const setSelectDay = ({commit}, data) => {
  return commit('SET_SELECT_DAY', data)
}

export const setSelectedYear = ({commit}, data) => {
  return commit('SET_SELECT_YEAR', data)
}

export const setUpdateVacations = ({commit}, data) => {
  return commit('SET_UPDATE_VACATIONS', data)
}

export const setUpdateHolidays = ({commit}, data) => {
  return commit('SET_UPDATE_HOLIDAYS', data)
}

export const setApiError = ({commit}, data) => {
  return commit('SET_API_ERROR', data)
}

export const setImportHolidaysSuccess = ({commit}, data) => {
  return commit('SET_IMPORT_HOLIDAYS_SUCCESS', data)
}

export const updateEvents = ({commit}, data) => {
  if (data) {
    return commit('UPDATE_VACATIONS')
  } else {
    return commit('UPDATE_HOLIDAYS')
  }
}

export const cancelHolidays = ({commit}, data) => {
  if (data) {
    return commit('CANCEL_VACATIONS')
  } else {
    return commit('CANCEL_HOLIDAYS')
  }
}

export const cancelRemove = ({commit}) => {
  return commit('CANCEL_REMOVE')
}

export const addHolidays = ({commit, state}, data) => {
  if (data) {
    const mutateVacationsQuery = gql`
      mutation addVacation($input:AddVacationInput!) {
        addVacation(input:$input) {
          ok
          errors
          vacation {
            id
            startDate
            endDate
            workingDays
          }
        }
      }
    `
    const vacation = {
      startDate: state.startDate,
      endDate: state.endDate
    }

    return graphClient.mutate({
      mutation: mutateVacationsQuery,
      variables: {
        input: vacation
      }
    })
      .then(data => {
        if (data.data.addVacation.ok) {
          commit('ADD_VACATIONS', data)
        } else {
          state.apiError = data.data.addVacation.errors[0]
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
  const mutateHolidaysQuery = gql`
    mutation addHoliday($input:AddHolidayInput!) {
      addHoliday(input:$input) {
        ok
        errors
        holiday {
          id
          date
        }
      }
    }
  `
  const holidays = {
    date: state.startDate,
    name: state.holidayName
  }

  return graphClient.mutate({
    mutation: mutateHolidaysQuery,
    variables: {
      input: holidays
    }
  })
    .then(data => {
      if (data.data.addHoliday.ok) {
        commit('ADD_HOLIDAYS', data)
      } else {
        state.apiError = data.data.addHoliday.errors[0]
      }
    })
    .catch(err => {
      console.error(err)
    })
}

export const setEditingId = ({commit, state}, data) => {
  return commit('EDIT_ID', data)
}

export const removeHolidays = ({commit, state}, data) => {
  if (data) {
    const mutateVacationsQuery = gql`
      mutation deleteVacation($input:DeleteVacationInput!) {
        deleteVacation(input: $input) {
          ok
          errors
        }
      }
    `
    const vacation = {
      id: state.editingId
    }

    return graphClient.mutate({
      mutation: mutateVacationsQuery,
      variables: {
        input: vacation
      }
    })
      .then(data => {
        if (data.data.deleteVacation.ok) {
          commit('REMOVE_VACATIONS')
        } else {
          state.apiError = data.data.deleteVacation.errors[0]
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
  const mutateHolidaysQuery = gql`
    mutation deleteHoliday($input: DeleteHolidayInput!) {
      deleteHoliday(input: $input) {
        ok
        errors
      }
    }
  `
  const holidays = {
    date: state.startDate
  }

  return graphClient.mutate({
    mutation: mutateHolidaysQuery,
    variables: {
      input: holidays
    }
  })
    .then(data => {
      if (data.data.deleteHoliday.ok) {
        commit('REMOVE_HOLIDAYS')
      } else {
        state.apiError = data.data.deleteHoliday.errors[0]
      }
    })
    .catch(err => {
      console.error(err)
    })
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js